import { Component, Input, OnInit, HostListener, Renderer2, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { TimeEntryModel } from '../../../common/models/TimeEntry.model';
import { FormControl, FormGroup } from '@angular/forms';
import { getCurrentUser } from 'app/core/store/currentUser/user.selectors';
import { Store } from '@ngrx/store';
import { ConsultantModel } from '../../../common/models/consultant.model';
import { DateUtility } from '../../../common/utilities/date.utility';
import { EntryDialogComponent } from '../entry-dialog/entry-dialog.component';
import { GridApi } from 'ag-grid-community';
import { Constants } from '../../../common/utilities/constants.config';
import { getTimeDateRange } from 'app/core/store/timeDateRangeSelection/timeDateRangeSelection.selectors';
import { getExpenseDateRange } from 'app/core/store/expenseDateRangeSelection/expenseDateRangeSelection.selectors';
import { commonFunctions } from '../../../common/classes/common.class';
import { TimeEntryService } from '../../../common/services/time-entry.service';
import { PlanActualComparisionDialogComponent } from 'app/core/mips/actuals/time-entry/plan-actual-comparision-dialog/plan-actual-comparision-dialog.component';
import { SnackbarService } from '../../../common/services/snackbar.service';
import { EntryTableService } from '../../../common/services/entry-table.service';
import { FlagEntryService } from '../../../common/services/flag-entry.service';
import { setTimeDateRangeSelection } from 'app/core/store/timeDateRangeSelection/timeDateRangeSelection.actions';
import { DateRangeModel } from '../../../common/models/date-range.model';
import { DatePipe } from '@angular/common';
import { getTimeEntryGridConfig } from 'app/core/store/timeEntryGridConfig/timeEntryGridConfig.selector';
import { setTimeEntryGridConfig } from 'app/core/store/timeEntryGridConfig/timeEntryGridConfig.actions';
import { setExpenseDateRangeSelection } from 'app/core/store/expenseDateRangeSelection/expenseDateRangeSelection.actions';
import { ExpenseEntryService } from '../../../common/services/expense-entry.service';
import { ExpenseEntryModel } from '../../../common/models/ExpenseEntry.model';
import { setExpenseEntryGridConfig } from 'app/core/store/expenseEntryGridConfig/expenseEntryGridConfig.actions';
import { getExpenseEntryGridConfig } from 'app/core/store/expenseEntryGridConfig/expenseEntryGridConfig.selector';
import { WriteSilenceService } from '../../../common/services/write-silence.service';
import { SustainabilityEntryService } from 'app/core/mips/common/services/sustainability-entry.service';
import { TransportModeService } from 'app/core/mips/common/services/transport-mode.service';
import { HttpClient } from '@angular/common/http';
import { forkJoin, concat } from 'rxjs';


@Component({
  selector: 'app-entry-header',
  templateUrl: './entry-header.component.html',
  styleUrls: ['./entry-header.component.scss'],
})
export class EntryHeaderComponent implements OnInit, OnChanges {
  @Input() entryPageType: string;
  isSmallScreenFlag: boolean;
  isLargeScreenFlag: boolean;
  isUnsavedChangesPresent: boolean;
  isRowSelectedforDeletion: boolean;
  currentUser: ConsultantModel;
  entryTDate: any;
  weekStart: string = '';
  weekEnd: string = '';
  agGridAPI: GridApi;
  agGridColumnAPI: any;
  getDateRange: any;
  setDateRange: any;
  entryCountHashMap: any;
  dateEntryCountHashMap: any;
  actualsAndChangedEntries: TimeEntryModel[];
  plannedTimeEntries: TimeEntryModel[];
  deletedEntries = [];
  entryGridConfig: any;
  entryService: any;
  rowDragMode: boolean;
  setEntryGridConfiguration: any;
  getEntryGridConfiguration: any;
  entryModel: any;
  isWriteSilence: boolean;
  login_name: string;
  month: number;
  year: number;

  dateRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  /**
   * Constructor
   */

  constructor(
    private _store: Store,
    private _dialog: MatDialog,
    private _timeEntryService: TimeEntryService,
    private _expenseEntryService: ExpenseEntryService,
    private _snackBarService: SnackbarService,
    private _entryTableService: EntryTableService,
    private _flagEntryService: FlagEntryService,
    private _datePipe: DatePipe,
    private _writeSilenceService: WriteSilenceService,
    private _renderer: Renderer2,
    private _sustainabilityService: SustainabilityEntryService,
    private _transportModeService: TransportModeService,
    private http: HttpClient
  ) {
    this.isSmallScreenFlag = false;
    this.isLargeScreenFlag = false;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.checkScreenSize();
    switch (this.entryPageType) {
      case Constants.NAV_TIME_ENTRY_ACTUALS:
        this.getDateRange = getTimeDateRange;
        this.entryCountHashMap = this._timeEntryService.entryCountHashMap;
        this.setDateRange = setTimeDateRangeSelection;
        this.entryService = this._timeEntryService;
        this.setEntryGridConfiguration = setTimeEntryGridConfig;
        this.getEntryGridConfiguration = getTimeEntryGridConfig;
        this.entryModel = TimeEntryModel;
        break;
      case Constants.NAV_EXPENSE_ENTRY:
        this.getDateRange = getExpenseDateRange;
        this.setDateRange = setExpenseDateRangeSelection;
        this.entryService = this._expenseEntryService;
        this.entryCountHashMap = this._expenseEntryService.entryCountHashMap;
        this.setEntryGridConfiguration = setExpenseEntryGridConfig;
        this.getEntryGridConfiguration = getExpenseEntryGridConfig;
        this.entryModel = ExpenseEntryModel;
        break;
    }
    this._writeSilenceService.writeSilence.subscribe((data) => {
      this.isWriteSilence = data;
    });
    this._store.select(this.getDateRange).subscribe((data) => {
      if (data) {
        this.weekStart = data['startDate'];
        this.weekEnd = data['endDate'];
      }
    });
    this.entryService.rowDragMode.subscribe((data) => {
      this.rowDragMode = data;
    });
    this.entryService.entryIsUnsavedChangesPresent.subscribe((data) => {
      this.isUnsavedChangesPresent = data;
    });
    this.entryService.entryisRowSelectedForDeletion.subscribe((data) => {
      this.isRowSelectedforDeletion = data;
    });

    this.entryService.entryCountHashMap.subscribe((data) => {
      this.dateEntryCountHashMap = data;
    });
    this._store.select(getCurrentUser).subscribe((data) => {
      this.currentUser = data;
    });
    this.entryService.entryActualsAndChanged.subscribe((data) => {
      this.actualsAndChangedEntries = data;
    });
    this.entryService.entryPlanned.subscribe((data) => {
      this.plannedTimeEntries = data;
    });
    this._store.select(this.getEntryGridConfiguration).subscribe((data) => {
      this.entryGridConfig = data;
    });
    this.dateRange.get('start').setValue(new Date(this.weekStart));
    this.dateRange.get('end').setValue(new Date(this.weekEnd));

    const element = document.querySelector(".mat-mdc-form-field.mat-form-field-appearance-fill .mat-mdc-form-field-subscript-wrapper");
    if (element) {
      this._renderer.setStyle(element, 'display', 'none', 1);
    }
  }

  /**
   * On changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.checkScreenSize();
    switch (this.entryPageType) {
      case Constants.NAV_TIME_ENTRY_ACTUALS:
        this.getDateRange = getTimeDateRange;
        this.entryCountHashMap = this._timeEntryService.entryCountHashMap;
        this.setDateRange = setTimeDateRangeSelection;
        this.entryService = this._timeEntryService;
        this.setEntryGridConfiguration = setTimeEntryGridConfig;
        this.getEntryGridConfiguration = getTimeEntryGridConfig;
        this.entryModel = TimeEntryModel;
        break;
      case Constants.NAV_EXPENSE_ENTRY:
        this.getDateRange = getExpenseDateRange;
        this.setDateRange = setExpenseDateRangeSelection;
        this.entryService = this._expenseEntryService;
        this.entryCountHashMap = this._expenseEntryService.entryCountHashMap;
        this.setEntryGridConfiguration = setExpenseEntryGridConfig;
        this.getEntryGridConfiguration = getExpenseEntryGridConfig;
        this.entryModel = ExpenseEntryModel;
        break;
    }
    this._writeSilenceService.writeSilence.subscribe((data) => {
      this.isWriteSilence = data;
    });
    this._store.select(this.getDateRange).subscribe((data) => {
      if (data) {
        this.weekStart = data['startDate'];
        this.weekEnd = data['endDate'];
      }
    });
    this.entryService.rowDragMode.subscribe((data) => {
      this.rowDragMode = data;
    });
    this.entryService.entryIsUnsavedChangesPresent.subscribe((data) => {
      this.isUnsavedChangesPresent = data;
    });
    this.entryService.entryisRowSelectedForDeletion.subscribe((data) => {
      this.isRowSelectedforDeletion = data;
    });

    this.entryService.entryCountHashMap.subscribe((data) => {
      this.dateEntryCountHashMap = data;
    });
    this._store.select(getCurrentUser).subscribe((data) => {
      this.currentUser = data;
    });
    this.entryService.entryActualsAndChanged.subscribe((data) => {
      this.actualsAndChangedEntries = data;
    });
    this.entryService.entryPlanned.subscribe((data) => {
      this.plannedTimeEntries = data;
    });
    this._store.select(this.getEntryGridConfiguration).subscribe((data) => {
      this.entryGridConfig = data;
    });
    this.dateRange.get('start').setValue(new Date(this.weekStart));
    this.dateRange.get('end').setValue(new Date(this.weekEnd));

    const element = document.querySelector(".mat-mdc-form-field.mat-form-field-appearance-fill .mat-mdc-form-field-subscript-wrapper");
    if (element) {
      this._renderer.setStyle(element, 'display', 'none', 1);
    }
  }

  // Set selected date range
  setDateRangeSelection() {
    let confirmRedirect = false;
    if (this.isUnsavedChangesPresent) {
      confirmRedirect = window.confirm(Constants.MSG_CONFIRM_DISCARD_CHANGES)
    }
    if (!this.isUnsavedChangesPresent || (this.isUnsavedChangesPresent && confirmRedirect)) {
      let week = new DateRangeModel();
      week['startDate'] = this._datePipe.transform(
        this.dateRange.value.start,
        'dd MMM yyyy'
      );
      week['endDate'] = this._datePipe.transform(
        this.dateRange.value.end,
        'dd MMM yyyy'
      );
      if (
        this.weekStart != week['startDate'] ||
        this.weekEnd != week['endDate']
      ) {
        if (week['endDate'] == null) {
          week['endDate'] = week['startDate']
          this.dateRange.get('end').setValue(new Date(week['endDate']));
        }
        this._store.dispatch(this.setDateRange({ week: week }));
      }
    }
    else {
      this.dateRange.get('start')?.setValue(new Date(this.weekStart));
      this.dateRange.get('end')?.setValue(new Date(this.weekEnd));
    }
  }

  //Set Date Entry Count Hashmap to store
  setDateEntryCountHashMap(dateEntryCountHashMap) {
    this.entryService.entryCountHashMap.next(dateEntryCountHashMap);
  }

  //Set boolean whether if any unsaved changes are present
  setEntryIsUnsavedChangesPresent(isUnsavedChangesPresent) {
    this.entryService.entryIsUnsavedChangesPresent.next(
      isUnsavedChangesPresent
    );
  }

  // Set the AG Grid Config
  setEntryGridConfig(entryGridConfig) {
    this._store.dispatch(this.setEntryGridConfiguration({ entryGridConfig }));
  }

  // Check for the Screen Size
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  // Check the screen size
  checkScreenSize() {
    this.isSmallScreenFlag = window.innerWidth < 768; // Example: small screens have width less than 768px
    this.isLargeScreenFlag = !this.isSmallScreenFlag;
  }

  isSmallScreen(): boolean {
    return this.isSmallScreenFlag;
  }

  isLargeScreen(): boolean {
    return this.isLargeScreenFlag;
  }

  // New Entry Dialog Box
  onNewButtonClicked(): void {
    this.entryTDate = this.entryService.getEntryTDate();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.data = new this.entryModel();
    dialogConfig.maxWidth = 'clamp(340px, 85vw, 800px)';
    dialogConfig.width = '100%';
    dialogConfig.height = 'auto';
    dialogConfig.data.Employee = this.currentUser.Employee;
    dialogConfig.data.TDate = this.entryTDate;
    if (this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
      dialogConfig.data.Invoice_Date = this.entryTDate;
    } else if (this.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
      dialogConfig.data.Invoice_date = this.entryTDate;
    }
    dialogConfig.data['startDate'] = this.weekStart;
    dialogConfig.data['endDate'] = this.weekEnd;
    dialogConfig.data.Mode = 'create';
    dialogConfig.data.entryPageType = this.entryPageType;
    const dialogRef = this._dialog.open(EntryDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result != typeof true && result != undefined) {
        this.setEntryIsUnsavedChangesPresent(true);
        result['status'] = 'create';
        this.agGridAPI = this.entryService.getGridApi();
        this.agGridAPI.applyTransaction({ add: [result] });
        if (
          this.dateEntryCountHashMap.get(result['TDate'].substr(0, 10)) === -1
        ) {
          this.agGridAPI.forEachNode((node) => {
            if (
              !commonFunctions.isNullOrUndefined(node.data) &&
              node.data.TDate === result['TDate'] &&
              node.data.status === 'dummy'
            ) {
              this.agGridAPI.applyTransaction({ remove: [node.data] });
            }
          });
          this.dateEntryCountHashMap.set(result['TDate'].substr(0, 10), 1);
        } else {
          this.dateEntryCountHashMap.set(
            result['TDate'].substr(0, 10),
            this.dateEntryCountHashMap.get(result['TDate'].substr(0, 10)) + 1
          );
        }
        this.setDateEntryCountHashMap(this.dateEntryCountHashMap);
        this.entryService.updateActualsAndChangedEntries(this.agGridAPI);
      }
    });
    this.entryService.setEntryTDate(DateUtility.formatStringfromDate(DateUtility.createDateType()));
  }

  // Plan Vs Actual Dialog Box
  planActualComparisionButtonClicked() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxWidth = 'clamp(340px, 92vw, 900px)';
    dialogConfig.width = '100%';
    dialogConfig.height = 'auto';
    // Check if there are actuals entered
    if (!commonFunctions.isNullOrUndefined(this.actualsAndChangedEntries)) {
      dialogConfig.data = this.plannedTimeEntries.concat(
        this.actualsAndChangedEntries
      );
    } else {
      dialogConfig.data = this.plannedTimeEntries;
    }
    dialogConfig.data.push(this.dateRange);
    const compareDialogRef = this._dialog.open(
      PlanActualComparisionDialogComponent,
      dialogConfig
    );
  }

  saveChangesButtonClicked(): void {
    this.agGridAPI = this.entryService.getGridApi();
    this.entryService.updateActualsAndChangedEntries(this.agGridAPI);
    this.setEntryIsUnsavedChangesPresent(false);

    let updateCreateEntries = this.actualsAndChangedEntries.filter((values) => {
      return (
        values.status !== 'clean' &&
        values.status !== 'dummy' &&
        values.status !== 'bad' &&
        values.status !== 'multiplerate'
      );
    });

    if (updateCreateEntries?.length > 0) {
      this._snackBarService.showSnackBar(Constants.SNACKBAR_MSG_SAVING_CHANGES, null, 'info');

      this.entryService.saveEntries(updateCreateEntries).subscribe(
        (response) => {
          if (!response['result']) {
            this._snackBarService.showSnackBar(
              response['Message'] || Constants.SNACKBAR_MSG_ENTRY_SAVE_FALIED,
              'close',
              'failure'
            );
          } else {
            this._snackBarService.showSnackBar(
              response['Message'] || Constants.SNACKBAR_MSG_ENTRY_SUCCESSFUL,
              '',
              'success'
            );
          }

          this._entryTableService.getEntryTableEntries(this.agGridAPI, this.entryPageType);

          type ExtendedTimeEntry = typeof updateCreateEntries[number] & {
            ExpenseID?: number;
            expense_id?: number;
            Description?: string;
            FromAirport?: string;
            ToAirport?: string;
            LayoverAirport1?: string;
            LayoverAirport2?: string;
            travel_id?: number | null;
            Office?: string;
            Login_Name?: string;
            TDate?: string;
            transportmode_desc?: string;
            DistanceUnit?: string;
            Distance?: number;
            is_roundtrip?: number | string | boolean | null;
            RoundTrip?: boolean | null;
          };

          // Track dragged entries that need sustainability data fetched
          const draggedTravelEntries: ExtendedTimeEntry[] = [];

          // --- Collect all new sustainability entries for batch save ---
          const newSustainabilityEntries = [];
          const existingUpdateEntries = [];

          // NEW: Track Plane Travel entries that need their OLD segments deleted (before creating new ones)
          const planeUpdateDeletes: Array<{
            expenseId: number;
            month: number;
            year: number;
            loginName: string;
          }> = [];

          const savedEntries = response.data as ExtendedTimeEntry[];
          console.log("FULL SAVE RESPONSE:", response);

          // Use ID-based mapping for existing entries, and sequential mapping for new entries
          // 1. Separate updated vs created entries
          const updateEntries = updateCreateEntries.filter(e => ['update', 'adls'].includes((e as any).status));
          const createEntries = updateCreateEntries.filter(e => (e as any).status === 'create' || (e as any).status === 'dummy');

          const getId = (e: any) => String(e?.ExpenseID || e?.expense_id || 'unmatched');

          // 2. Separate saved response entries into updated vs created
          const savedUpdateEntries = savedEntries.filter(s => updateEntries.some(u => getId(u) === getId(s) && getId(u) !== 'unmatched'));
          const savedCreateEntries = savedEntries.filter(s => !updateEntries.some(u => getId(u) === getId(s) && getId(u) !== 'unmatched'));

          // 3. Map safely
          // Update entries: IDs should remain unchanged, but safety check them
          updateEntries.forEach(entry => {
            const saved = savedUpdateEntries.find(s => getId(s) === getId(entry));
            if (saved) {
              (entry as any).ExpenseID = saved.ExpenseID || (saved as any).expense_id;
              (entry as any).expense_id = saved.ExpenseID || (saved as any).expense_id;
            }
          });

          // Create entries: Map to the newly generated ExpenseIDs sequentially
          createEntries.forEach((entry, index) => {
            if (index < savedCreateEntries.length) {
              const saved = savedCreateEntries[index];
              const newId = saved.ExpenseID || (saved as any).expense_id;
              if (newId) {
                (entry as any).ExpenseID = newId;
                (entry as any).expense_id = newId;
              }
            }
          });

          const resolveLoginName = (e: any) => this.currentUser?.LoginName || e.Entry_Owner_LoginName || e.Login_Name || e.LoginName || e.loginName;

          for (const entry of updateCreateEntries as ExtendedTimeEntry[]) {
            const isExisting = entry.travel_id && entry.travel_id > 0;

            // --- Only process sustainability for NEW entries (status='create') ---
            // Entries with status='update' were already processed in a previous Save action
            // Re-processing them causes overwrites in ADLS when combined with new entries
            // --- Allow both 'create' and 'update' status to proceed ---
            // derived "isExisting" logic below will handle the routing to save vs update


            // --- Plane Travel ---
            if (
              this.entryPageType === Constants.NAV_EXPENSE_ENTRY &&
              entry.Description === 'Plane Travel'
            ) {
              if (!entry.FromAirport || !entry.ToAirport) {

                // Collect this entry to fetch sustainability data later if it is a NEW entry
                if ((entry as any).status === 'create' || (entry as any).status === 'dummy') {
                  draggedTravelEntries.push(entry);
                }
                continue;
              }
              const layovers = [];
              if (entry.LayoverAirport1) layovers.push(entry.LayoverAirport1);
              if (entry.LayoverAirport2) layovers.push(entry.LayoverAirport2);

              const origin = entry.FromAirport;
              const destination = entry.ToAirport;
              const segments: [string, string][] = [];

              if (layovers.length === 0) {
                segments.push([origin, destination]);
              } else {
                segments.push([origin, layovers[0]]);
                for (let i = 0; i < layovers.length - 1; i++) {
                  segments.push([layovers[i], layovers[i + 1]]);
                }
                segments.push([layovers[layovers.length - 1], destination]);
              }
              const roundTripValue = this.normalizeRoundTrip(entry);

              const sustainabilityEntriesForSegments = segments.map(([from, to]) => ({
                travel_id: entry.travel_id || 0,
                expense_id: entry.ExpenseID,
                travel_type_desc: 'Business',
                transportmode_desc: 'Plane',
                office_desc: this.currentUser.Country_Description,
                login_name: resolveLoginName(entry),
                month: this.getMonth(new Date(entry.TDate)),
                year: new Date(entry.TDate).getFullYear(),
                plane_frequency: roundTripValue === 1 ? 2 : 1,
                plane_origin_desc: from,
                plane_destination_desc: to,
                is_roundtrip: roundTripValue,
                distance_unit: null,
                distance: null,
              }));

              if (isExisting) {
                // STRATEGY: For Plane Travel updates (which involved structural changes like layovers),
                // we DELETE ALL old segments and CREATE ALL new segments.
                // This avoids "partial update" issues and backend errors with partition keys.

                // 1. Queue OLD segments for deletion (Lookup by ExpenseID)
                planeUpdateDeletes.push({
                  expenseId: entry.ExpenseID,
                  month: this.getMonth(new Date(entry.TDate)),
                  year: new Date(entry.TDate).getFullYear(),
                  loginName: resolveLoginName(entry)
                });

                // 2. Treat ALL current segments as NEW (Force Create)
                sustainabilityEntriesForSegments.forEach(seg => {
                  seg.travel_id = 0; // Force create
                });
                newSustainabilityEntries.push(...sustainabilityEntriesForSegments);

              } else {
                newSustainabilityEntries.push(...sustainabilityEntriesForSegments);
              }
            }

            // --- Taxi / Train Travel / Motor Vehicle Hire ---
            if (
              this.entryPageType === Constants.NAV_EXPENSE_ENTRY &&
              (entry.Description === 'Mileage' || entry.Description === 'Motor Vehicle Hire' || entry.Description === 'Train Travel' || entry.Description === 'Train/Bus Travel' || entry.Description === 'Taxi Travel' || entry.Description === 'Taxi travel')
            ) {
              // Check if transportmode_desc and Distance exist
              if (!entry.transportmode_desc || entry.transportmode_desc === 'No Travel' || !entry.Distance) {

                // Collect this entry to fetch sustainability data later if it is a NEW entry
                if ((entry as any).status === 'create' || (entry as any).status === 'dummy') {
                  draggedTravelEntries.push(entry);
                }
                continue; // Skip for now - will process after fetching sustainability data
              }
              const sustainabilityEntry = {
                travel_id: isExisting ? entry.travel_id : 0,
                expense_id: entry.ExpenseID,
                travel_type_desc: 'Business',
                transportmode_desc: entry.transportmode_desc || 'No Travel',
                office_desc: this.currentUser.Country_Description,
                login_name: resolveLoginName(entry),
                month: this.getMonth(new Date(entry.TDate)),
                year: new Date(entry.TDate).getFullYear(),
                distance_unit: entry.DistanceUnit || 'km',
                distance: entry.Distance || 0,
                plane_frequency: null,
                plane_origin_desc: null,
                plane_destination_desc: null,
                is_roundtrip: 0,
              };

              if (isExisting) {
                const month = this.getMonth(new Date(entry.TDate));
                const year = new Date(entry.TDate).getFullYear();
                const loginName = resolveLoginName(entry);
                existingUpdateEntries.push({ entry: sustainabilityEntry, month, year, loginName });
              } else {
                newSustainabilityEntries.push(sustainabilityEntry);
              }
            }
          }

          // --- Collect all operations sequentially to avoid ADLS parquet concurrent write corruption ---
          const executeSequentialSaves = () => {
            const observables = [];

            // 1. Post all NEW entries grouped together
            if (newSustainabilityEntries.length > 0) {
              observables.push(this._sustainabilityService.saveEntries(newSustainabilityEntries));
            }

            // 2. Put all UPDATE entries
            for (const updateItem of existingUpdateEntries) {
              observables.push(this._sustainabilityService.updateEntry(updateItem.entry, updateItem.month, updateItem.year, updateItem.loginName));
            }

            // Execute all observables one by one strictly sequentially
            if (observables.length > 0) {
              concat(...observables).subscribe({
                next: () => { },
                error: (err) => console.error('Sustainability save sequence error:', err),
                complete: () => console.log('Sequenced sustainability saves complete.')
              });
            }
          };

          // --- Priority 1: Handle Plane Updates (Delete Old first) ---
          if (planeUpdateDeletes.length > 0) {
            const monthsToFetch = new Set<string>();
            planeUpdateDeletes.forEach(d => monthsToFetch.add(`${d.year}-${d.month}`));

            this._sustainabilityService.getSustainabilityData(
              Array.from(monthsToFetch),
              this.currentUser.LoginName
            ).subscribe({
              next: (sustainabilityDataArray) => {
                const allSustainabilityData = Array.isArray(sustainabilityDataArray) ? sustainabilityDataArray.flat() : sustainabilityDataArray;
                const deletionsMap = new Map<string, any[]>();

                allSustainabilityData.forEach(susEntry => {
                  planeUpdateDeletes.filter(d => Number(d.expenseId) === Number(susEntry.expense_id)).forEach(match => {
                    const key = `${match.year}-${match.month}-${match.loginName}`;
                    if (!deletionsMap.has(key)) deletionsMap.set(key, []);
                    deletionsMap.get(key).push({ travel_id: susEntry.travel_id, loginName: match.loginName });
                  });
                });

                let pendingDeletes = 0;
                deletionsMap.forEach(ids => { if (ids.length > 0) pendingDeletes++; });

                if (pendingDeletes === 0) {
                  executeSequentialSaves();
                } else {
                  deletionsMap.forEach((items, key) => {
                    const [year, month, loginName] = key.split('-');
                    if (items.length > 0) {
                      const ids = items.map(i => i.travel_id);
                      this._sustainabilityService.deleteEntries(ids, Number(month), Number(year), loginName)
                        .subscribe({
                          next: () => { },
                          error: (err) => { console.error('Error deleting old plane segments', err); },
                          complete: () => {
                            pendingDeletes--;
                            if (pendingDeletes === 0) executeSequentialSaves();
                          }
                        });
                    }
                  });
                }
              },
              error: (err) => {
                console.error('Error fetching sustainability data for plane updates', err);
                executeSequentialSaves();
              }
            });
          } else {
            // No deletes needed, proceed strictly to save sequentially
            executeSequentialSaves();
          }

          // --- Process dragged travel entries (Independent, but we will make it disjointed gracefully) ---
          if (draggedTravelEntries.length > 0) {
            const draggedObservables = [];

            // Assume all dragged entries in this batch belong to the same impersonated user
            const draggedLoginName = resolveLoginName(draggedTravelEntries[0]);

            const monthsToFetch = new Set<string>();
            draggedTravelEntries.forEach(entry => {
              const sourceDateStr = (entry as any).__sourceDate || entry.TDate;
              const date = new Date(sourceDateStr);
              monthsToFetch.add(`${date.getFullYear()}-${this.getMonth(date)}`);
            });

            this._sustainabilityService.getSustainabilityData(
              Array.from(monthsToFetch),
              draggedLoginName
            ).subscribe({
              next: (sustainabilityDataArray) => {
                const sustainabilityData = Array.isArray(sustainabilityDataArray) ? sustainabilityDataArray.flat() : sustainabilityDataArray;
                const newlyGeneratedSustainabilityEntries = [];

                draggedTravelEntries.forEach(draggedEntry => {
                  const entryDate = new Date(draggedEntry.TDate);
                  const entryMonth = this.getMonth(entryDate);
                  const entryYear = entryDate.getFullYear();

                  if (draggedEntry.Description === 'Plane Travel') {
                    const sourceExpenseId = (draggedEntry as any).__sourceExpenseId || draggedEntry.expense_id;
                    let planeEntries = [];
                    if (sourceExpenseId) {
                      planeEntries = sustainabilityData.filter(s => s.transportmode_desc === 'Plane' && s.expense_id === sourceExpenseId);
                    }

                    const originDesc = planeEntries.length > 0 ? planeEntries[0].plane_origin_desc : ((draggedEntry as any).plane_origin_desc || draggedEntry.FromAirport || null);
                    const destDesc = planeEntries.length > 0 ? planeEntries[0].plane_destination_desc : ((draggedEntry as any).plane_destination_desc || draggedEntry.ToAirport || null);
                    const roundTripValueForFrequency = this.normalizeRoundTrip(draggedEntry);
                    const frequency = roundTripValueForFrequency === 1 ? 2 : 1;

                    newlyGeneratedSustainabilityEntries.push({
                      travel_id: 0,
                      expense_id: draggedEntry.ExpenseID,
                      travel_type_desc: 'Business',
                      transportmode_desc: 'Plane',
                      office_desc: this.currentUser.Country_Description,
                      login_name: resolveLoginName(draggedEntry),
                      month: entryMonth,
                      year: entryYear,
                      plane_frequency: frequency,
                      plane_origin_desc: originDesc,
                      plane_destination_desc: destDesc,
                      is_roundtrip: this.normalizeRoundTrip(draggedEntry),
                      distance_unit: null,
                      distance: null,
                    });
                  } else if (
                    ['Mileage', 'Motor Vehicle Hire', 'Train Travel', 'Train/Bus Travel', 'Taxi Travel', 'Taxi travel'].includes(draggedEntry.Description as string)
                  ) {
                    const sourceExpenseId = (draggedEntry as any).__sourceExpenseId || draggedEntry.expense_id;
                    let matchingEntries = [];
                    if (sourceExpenseId) {
                      matchingEntries = sustainabilityData.filter(s => s.expense_id === sourceExpenseId);
                    }

                    const fallbackTransportDesc = (draggedEntry as any).transportModes || (draggedEntry as any).transportmode_desc || (['Mileage', 'Motor Vehicle Hire', 'Taxi Travel', 'Taxi travel'].includes(draggedEntry.Description) ? 'Taxi' : 'Train');

                    const transportDesc = matchingEntries.length > 0 ? matchingEntries[0].transportmode_desc : fallbackTransportDesc;
                    const distanceUnit = matchingEntries.length > 0 ? (matchingEntries[0].distance_unit || 'km') : (draggedEntry.DistanceUnit || (draggedEntry as any).distance_unit || 'km');
                    const distanceAmt = matchingEntries.length > 0 ? (matchingEntries[0].distance || 0) : ((draggedEntry as any).Distance || (draggedEntry as any).distance || 0);

                    newlyGeneratedSustainabilityEntries.push({
                      travel_id: 0,
                      expense_id: draggedEntry.ExpenseID,
                      travel_type_desc: 'Business',
                      transportmode_desc: transportDesc,
                      office_desc: this.currentUser.Country_Description,
                      login_name: resolveLoginName(draggedEntry),
                      month: entryMonth,
                      year: entryYear,
                      distance_unit: distanceUnit,
                      distance: distanceAmt,
                      plane_frequency: null,
                      plane_origin_desc: null,
                      plane_destination_desc: null,
                      is_roundtrip: 0
                    });
                  }
                });

                // Save these completely disjointed newly generated sustainability items using a single batch if any
                if (newlyGeneratedSustainabilityEntries.length > 0) {
                  this._sustainabilityService.saveEntries(newlyGeneratedSustainabilityEntries).subscribe();
                }
              },

              error: (err) => {
                console.error('[TRAVEL DRAG] ✗ Failed to fetch sustainability data:', err);
                this._snackBarService.showSnackBar(
                  'Failed to fetch data for dragged travel entries. Please edit them to add details.',
                  null,
                  'failure'
                );
              }
            });
          }

          // Reinsert flagged entries
          for (const values of this.actualsAndChangedEntries) {
            if (
              values &&
              (values.status === 'bad' || values.status === 'multiplerate') &&
              values.TDate
            ) {
              this.entryService.addRecordsToGrid(this.agGridAPI, values);
            }
          }
        },
        (error) => {
          this._snackBarService.showSnackBar(
            Constants.SNACKBAR_MSG_ENTRY_SAVE_FALIED,
            'close',
            'failure'
          );
        }
      );
    }
  }


  getMonth(date: Date): number {
    return (date.getMonth() + 1);
  }


  private normalizeRoundTrip(e: { is_roundtrip?: any; RoundTrip?: any }): number {
    if (e?.is_roundtrip !== undefined && e?.is_roundtrip !== null && e?.is_roundtrip !== '') {
      return Number(e.is_roundtrip) === 1 ? 1 : 0;
    }
    if (e?.RoundTrip !== undefined && e?.RoundTrip !== null) {
      return e.RoundTrip === true ? 1 : 0;
    }
    return 0;
  }

  // Delete Selected Rows
  deleteButtonClicked(): void {
    const confirmDeletion = window.confirm(Constants.MSG_CONFIRM_DELETE_RECORDS);
    if (confirmDeletion) {
      this.agGridAPI = this.entryService.getGridApi();
      const selectedRows = this.agGridAPI.getSelectedRows();
      const travelEntriesToDelete: Array<{
        travelId: number;
        month: number;
        year: number;
        loginName: string;
      }> = [];

      // NEW: Collect expense entries that need sustainability deletion (without travel_id)
      const expenseEntriesNeedingSustainabilityDelete: Array<{
        date: string;
        description: string;
        month: number;
        year: number;
        expenseId?: number;
      }> = [];

      selectedRows.filter((value) => {
        console.log('Selected Row:', value);
        console.log('travel_id:', value?.travel_id);
        if (value.status !== 'dummy') {

          // Collect travel-related expense entries
          const isTravelDescription =
            value.Description === 'Plane Travel' ||
            value.Description === 'Mileage' ||
            value.Description === 'Motor Vehicle Hire' ||
            value.Description === 'Train Travel' ||
            value.Description === 'Train/Bus Travel' ||
            value.Description === 'Taxi Travel' ||
            value.Description === 'Taxi travel';

          // Check if entry has sustainability data (with travel_id)
          if (
            this.entryPageType === Constants.NAV_EXPENSE_ENTRY &&
            value.travel_id &&
            value.travel_id > 0 &&
            value.TDate &&
            isTravelDescription &&
            value.Description !== 'Plane Travel' // Force Plane Travel to use lookup path (else if block)
          ) {
            const entryDate = new Date(value.TDate);
            const travelEntry = {
              travelId: value.travel_id,
              month: entryDate.getMonth() + 1,
              year: entryDate.getFullYear(),
              loginName: this.currentUser.LoginName,
            };
            travelEntriesToDelete.push(travelEntry);
          }
          // NEW: Also collect travel expenses WITHOUT travel_id - we'll fetch and match sustainability data
          else if (
            this.entryPageType === Constants.NAV_EXPENSE_ENTRY &&
            value.TDate &&
            isTravelDescription &&
            value.status !== 'create' // Only for saved entries (not just dragged)
          ) {
            const entryDate = new Date(value.TDate);
            const expenseEntry = {
              date: value.TDate,
              description: value.Description,
              month: entryDate.getMonth() + 1,
              year: entryDate.getFullYear(),
              expenseId: value.ExpenseID || value.expense_id || value.Expense_ID || value.expenseId // Check all property variations
            };
            expenseEntriesNeedingSustainabilityDelete.push(expenseEntry);
          }
          // Skip sustainability deletion for entries that were just dragged but not saved yet
          else if (
            this.entryPageType === Constants.NAV_EXPENSE_ENTRY &&
            value.TDate &&
            isTravelDescription &&
            value.status === 'create'
          ) {

          } else {
            // Enhanced logging to show why entry was not included
            if (this.entryPageType === Constants.NAV_EXPENSE_ENTRY) {
            }
          }

          // Remove the row visually
          this.agGridAPI.applyTransaction({ remove: [value] });

          if (this.dateEntryCountHashMap.get(value.TDate.substr(0, 10)) === 1) {
            this._entryTableService.addEmptyRowForEntryDate(
              value.TDate.substr(0, 10),
              this.agGridAPI
            );
          } else {
            this.dateEntryCountHashMap.set(
              value.TDate.substr(0, 10),
              this.dateEntryCountHashMap.get(value.TDate.substr(0, 10)) - 1
            );
            this.setDateEntryCountHashMap(this.dateEntryCountHashMap);
          }

          if (
            (!commonFunctions.isNullOrUndefined(value.Time_ID) &&
              value.Time_ID !== 0) ||
            (!commonFunctions.isNullOrUndefined(value.ExpenseID) &&
              value.ExpenseID !== 0)
          ) {
            this.deletedEntries.push(value);
          }
        }
      });

      if (
        !commonFunctions.isNullOrUndefined(this.deletedEntries) &&
        this.deletedEntries.length > 0
      ) {
        this._snackBarService.showSnackBar(
          Constants.SNACKBAR_MSG_SAVING_CHANGES,
          null,
          'info'
        );

        const deleteTSEXEntry = this.deletedEntries.filter((values) => {
          return (
            values.Client === 'AD' &&
            (values.Project === 'TS' || values.Project === 'EX')
          );
        });

        // === MAIN DELETE CALL (SSMS / Expense API) ===
        this.entryService.deleteEntries(this.deletedEntries).subscribe({
          next: (response) => {
            if (!response['result']) {
              console.error('Main delete failed:', response['Message']);
              this._snackBarService.showSnackBar(
                response['Message'] || Constants.SNACKBAR_MSG_ENTRY_DELETE_FALIED,
                'close',
                'failure'
              );
              this._entryTableService.getEntryTableEntries(
                this.agGridAPI,
                this.entryPageType
              );
              return;
            }

            this.deletedEntries = [];
            this._snackBarService.showSnackBar(
              response['Message'] || Constants.SNACKBAR_MSG_ENTRY_DELETION,
              '',
              'success'
            );
            // === Consolidated Delete Logic ===
            const executeConsolidatedDelete = (extraIds: Array<{ travelId: number, month: number, year: number }>) => {
              // 1. Combine direct travel IDs with those found via lookup
              const allDeletes: Array<{
                travelId: number;
                month: number;
                year: number;
                loginName: string;
              }> = [...travelEntriesToDelete];

              if (extraIds.length > 0) {
                extraIds.forEach(item => {
                  allDeletes.push({
                    travelId: item.travelId,
                    month: item.month,
                    year: item.year,
                    loginName: this.currentUser.LoginName
                  });
                });
              }

              if (allDeletes.length > 0) {
                // 2. Group by partition (Month-Year-LoginName)
                const groupedDeletes = allDeletes.reduce((acc, entry) => {
                  const key = `${entry.month}-${entry.year}-${entry.loginName}`;
                  if (!acc[key]) {
                    acc[key] = {
                      travelIds: [],
                      month: entry.month,
                      year: entry.year,
                      loginName: entry.loginName,
                    };
                  }
                  // Avoid duplicates if any
                  if (!acc[key].travelIds.includes(entry.travelId)) {
                    acc[key].travelIds.push(entry.travelId);
                  }
                  return acc;
                }, {} as any);

                // 3. Send one request per group
                Object.values(groupedDeletes).forEach((group: any, index: number) => {
                  this._sustainabilityService
                    .deleteEntries(
                      group.travelIds,
                      group.month,
                      group.year,
                      group.loginName
                    )
                    .subscribe({
                      next: (result) => {
                        console.log(`Group ${index + 1} deleted successfully`);
                      },
                      error: (err) => {
                        console.error(`✗ ERROR - Group ${index + 1} deletion failed`);
                        console.error('Error:', err);
                        this._snackBarService.showSnackBar(
                          'Info: Some ADLS entries may not have been deleted. Check console.',
                          'close',
                          'failure'
                        );
                      },
                    });
                });
              } else {
                console.log('No sustainability entries to delete from ADLS');
              }
            };

            // CASE 1: Need to lookup sustainability IDs for some entries
            if (expenseEntriesNeedingSustainabilityDelete.length > 0) {
              // Build unique year-month combinations to fetch
              const monthsToFetch = new Set<string>();
              expenseEntriesNeedingSustainabilityDelete.forEach(entry => {
                monthsToFetch.add(`${entry.year}-${String(entry.month).padStart(2, '0')}`);
              });

              // We can safely assume all selected entries for deletion belong to the same impersonated user
              const resolveLoginName = (e: any) => this.currentUser?.LoginName || e.Entry_Owner_LoginName || e.Login_Name || e.LoginName || e.loginName;
              const draggedLoginName = resolveLoginName(expenseEntriesNeedingSustainabilityDelete[0]);

              // Fetch both transport modes and sustainability data
              forkJoin({
                transportModes: this._transportModeService.getTransportModes(),
                sustainabilityData: this._sustainabilityService.getSustainabilityData(
                  Array.from(monthsToFetch),
                  draggedLoginName
                )
              }).subscribe({
                next: ({ transportModes, sustainabilityData }) => {
                  // Dynamically find transport mode IDs by description
                  const findModeIdsByDescriptions = (descriptions: string[]): number[] => {
                    return transportModes
                      .filter(mode => descriptions.includes(mode.transportmode_desc))
                      .map(mode => mode.transportmode_id);
                  };

                  const descriptionToModeDescriptions: { [key: string]: string[] } = {
                    'Plane Travel': ['Plane'],
                    'Mileage': ['Gas/Petrol Car', 'Diesel Car', 'Hybrid/CNG/LPG Car', 'Electric Car'],
                    'Motor Vehicle Hire': ['Gas/Petrol Car', 'Diesel Car', 'Hybrid/CNG/LPG Car', 'Electric Car'],
                    'Train Travel': ['Train', 'Metro/Tube/Subway/Underground'],
                    'Train/Bus Travel': ['Train', 'Metro/Tube/Subway/Underground', 'Bus'],
                    'Taxi Travel': ['Taxi'],
                    'Taxi travel': ['Taxi'],
                  };

                  // Build the mapping from expense description to transport mode names
                  const descriptionToModeNames: { [key: string]: string[] } = {};
                  Object.keys(descriptionToModeDescriptions).forEach(desc => {
                    const modeDescriptions = descriptionToModeDescriptions[desc];
                    const modeIds = findModeIdsByDescriptions(modeDescriptions);
                    const modeNames = transportModes
                      .filter(mode => modeIds.includes(mode.transportmode_id))
                      .map(mode => mode.transportmode_desc);
                    descriptionToModeNames[desc] = modeNames;
                  });

                  // Find matching sustainability entries to delete
                  const sustainabilityIdsToDelete: Array<{
                    travelId: number;
                    month: number;
                    year: number;
                  }> = [];

                  expenseEntriesNeedingSustainabilityDelete.forEach(expenseEntry => {
                    const matchingModes = descriptionToModeNames[expenseEntry.description] || [];
                    const targetExpenseId = expenseEntry.expenseId ? Number(expenseEntry.expenseId) : null;

                    // 1. Precise Match: Try to match by ExpenseID first (reliable for newer entries)
                    let matches = [];
                    if (targetExpenseId) {
                      matches = sustainabilityData.filter(sEntry => {
                        const sEntryMonth = Number(sEntry.month);
                        const sEntryYear = Number(sEntry.year);
                        const sEntryExpenseId = sEntry.expense_id ? Number(sEntry.expense_id) : null;
                        return (
                          sEntryMonth === expenseEntry.month &&
                          sEntryYear === expenseEntry.year &&
                          sEntryExpenseId !== null &&
                          sEntryExpenseId === targetExpenseId
                        );
                      });
                    }

                    // 2. Strict Fallback: ONLY if expenseId was NOT present on the deleted expense row
                    if (matches.length === 0 && !targetExpenseId) {
                      const candidateMatches = sustainabilityData.filter(sEntry => {
                        const sEntryMonth = Number(sEntry.month);
                        const sEntryYear = Number(sEntry.year);
                        const matchingMode = matchingModes.includes(sEntry.transportmode_desc);
                        return (
                          sEntryMonth === expenseEntry.month &&
                          sEntryYear === expenseEntry.year &&
                          matchingMode
                        );
                      });

                      // Protect month data: Only delete if there is EXACTLY 1 candidate match.
                      // If there are multiple candidate entries in the month, DO NOT mass delete them.
                      if (candidateMatches.length === 1) {
                        matches = candidateMatches;
                      } else if (candidateMatches.length > 1) {
                        console.warn('[SUSTAINABILITY DELETE] Multiple candidate entries found for month without ExpenseID match. Skipping deletion to prevent wiping month data.');
                      }
                    }

                    if (matches.length > 0) {
                      // Delete ALL matching sustainability entries for this specific expense
                      matches.forEach(match => {
                        sustainabilityIdsToDelete.push({
                          travelId: match.travel_id,
                          month: expenseEntry.month,
                          year: expenseEntry.year
                        });
                      });
                    }
                  });

                  // Execute delete with found IDs
                  executeConsolidatedDelete(sustainabilityIdsToDelete);
                },
                error: (err) => {
                  console.error('Failed to fetch sustainability data for matching:', err);
                  // Fallback: Try deleting what we have (travelEntriesToDelete)
                  executeConsolidatedDelete([]);
                }
              });
            } else {
              // CASE 2: No lookup needed, just delete direct IDs
              executeConsolidatedDelete([]);
            }

            if (
              !commonFunctions.isNullOrUndefined(deleteTSEXEntry) &&
              deleteTSEXEntry.length > 0 &&
              this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS
            ) {
              this._flagEntryService.getFlagEntry().subscribe();
            }
          },
          error: (error) => {
            console.error('Main delete entries error:', error);
            this._snackBarService.showSnackBar(
              Constants.SNACKBAR_MSG_ENTRY_DELETE_FALIED,
              'close',
              'failure'
            );
          },
        });
      } else {
      }

      this.entryService.updateActualsAndChangedEntries(this.agGridAPI);

      const checkForDirtyRows = this.actualsAndChangedEntries.filter(
        (entry) => entry.status !== 'clean' && entry.status !== 'dummy'
      );

      if (
        commonFunctions.isNullOrUndefined(checkForDirtyRows) ||
        checkForDirtyRows.length === 0
      ) {
        this.setEntryIsUnsavedChangesPresent(false);
      }
    }
  }



  // Reset Data
  resetChangesButtonClicked(): void {
    const confirmReset = window.confirm(
      Constants.MSG_CONFIRM_RESET_ENTRY
    );
    if (confirmReset) {
      this._entryTableService.getEntryTableEntries(
        this.entryService.getGridApi(),
        this.entryPageType
      );
    }
  }

  // Reset Columns
  resetColumnsButtonClicked(): void {
    let tempEntryGridConfig = { ...this.entryGridConfig };
    this.agGridColumnAPI = this.entryService.getGridColumnApi();
    if (!commonFunctions.isNullOrUndefined(this.agGridColumnAPI)) {
      this.agGridColumnAPI.resetColumnState();
      if (
        !commonFunctions.isNullOrUndefined(tempEntryGridConfig) &&
        tempEntryGridConfig.id !== 0
      ) {
        tempEntryGridConfig.Configuration = JSON.stringify(
          this.agGridColumnAPI.getColumnState()
        );
        this.setEntryGridConfig(tempEntryGridConfig);
      }
    }
    this.entryService.setGridColumnApi(this.agGridColumnAPI);
  }

  // Toggle between Move and Copy
  toggleValueChanged() {
    this.entryService.rowDragMode.next(!this.rowDragMode);
  }
}
